export default __webpack_public_path__ + "static/media/pic12.945b574f.jpg";